module.exports = __webpack_public_path__ + "static/media/base_hero.33299f8d.png";